// extracted by mini-css-extract-plugin
export default {"horizontalSeparator":"Section_horizontalSeparator__nfMti","emptyState":"Section_emptyState__yKzUl"};